import { clsx } from 'clsx'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import { profilePicture40 } from '~/styles/picture.css'
import {
  applicantCardContent,
  identity,
  name,
  nameShimmer,
  wrapper
} from './ApplicantCard.css'

export const ApplicantCardShimmer = () => {
  return (
    <div className={clsx(wrapper, applicantCardContent)}>
      <div className={identity}>
        <div className={profilePicture40}>
          <Shimmer width={40} height={40} />
        </div>
        <div className={clsx(name, nameShimmer)}>
          <Shimmer width="100%" height="1rem" />
          <Shimmer width="100px" height="1rem" />
        </div>
      </div>
    </div>
  )
}
